webpackJsonp([7],{

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Assorted libraries that must be on the global namespace.
 * We should try to not use this as much as possible.
 * @type {_|exports|module.exports}
 * @private
 *
 * Understand the expose-loader: https://github.com/webpack/expose-loader
 */

__webpack_require__(69);

// Bind polyfill
// PhantomJS doesn't support bind yet
Function.prototype.bind = Function.prototype.bind || function (that) {
  var fn = this;
  return function () {
    return fn.apply(that, arguments);
  };
};

window.Bloodhound = __webpack_require__(1247);
window.Strftime = __webpack_require__(1248);
window._ = __webpack_require__(29);
window.herment = __webpack_require__(1249);
window.typeahead = __webpack_require__(1251);

/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*global define:false */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1250)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {

  var herment_client = window['herment-gas-client'];

  function init(config) {
    if (herment_client && herment_client.is_started) {
      herment_client.stop();
      herment_client.config = herment_client.parseConfig(config);
    } else {
      herment_client = new Herment(config);
      window['herment-gas-client'] = herment_client;
    }
    return herment_client;
  }

  function Herment(options) {

    this.STORAGE_KEY_PREAMBLE = 'herment';
    this.MAXEVENTS = 100;
    this.PUBLISH_INTERVAL = 5000;
    this.SAVE_INTERVAL = 1000;

    this.config = this.parseConfig(options);

    this.storage = utils.getStorage();

    this.is_started = false;

    /**
     * Saves any leftovers in the queue to the sessionStorage before user navigates away
     */
    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('unload', function () {
        this.moveQueueToStorage();
      }.bind(this));
    } else {
      window.attachEvent('onunload', function () {
        this.moveQueueToStorage();
      }.bind(this));
    }

    return this;
  }

  Herment.prototype = {

    /**
     * Retrieves the __atl_path cookie value
     *
     * @returns {*} atlPath
     */
    getAtlPath: function getAtlPath() {
      return utils.getCookieValue('__atl_path');
    },

    /**
     * Identifies the server name by the url and returns
     * Called in publish
     *
     * @returns {*} serverName
     */
    getServerName: function getServerName() {
      var serverName;
      if (typeof document.location !== 'undefined') {
        if (typeof document.location.hostname !== 'undefined') {
          serverName = document.location.hostname;
        }
      }
      if (serverName === '') {
        serverName = '-';
      }
      return serverName;
    },

    /**
     * Computes server name based on the serverName
     * Called in publish
     *
     * @returns {*} productName
     */
    getProductNameFromServerName: function getProductNameFromServerName(localServerName) {
      if (typeof localServerName !== 'undefined') {
        return localServerName.replace('.com', '').replace('.net', '').replace('.org', '').replace('.au', '').replace('.io', '');
      } else {
        return '-';
      }
    },

    /**
     * extracts sub-domain or '-'
     * Called in addEventsToArray
     *
     * @returns {*} subdomain or -
     */
    getSubdomain: function getSubdomain(fullServerName) {
      var subdomain = '-';
      var domain = fullServerName.match(/^([a-z0-9\.]*)[\-\.]{1}([a-z0-9]+)+\.([a-z]{2,6})$/i);

      if (domain) {
        var parts = fullServerName.split('.');
        if (parts[parts.length - 1].length === 2) {
          parts = parts.slice(0, parts.length - 3);
        } else {
          parts = parts.slice(0, parts.length - 2);
        }
        if (parts.length !== 0) {
          subdomain = parts.join('.');
        }
      }
      return subdomain;
    },

    /**
     * Generate random number that's
     *  - unique
     *  - limited to 20 characters
     */
    generateRandomStorageKey: function generateRandomStorageKey() {
      var StringSliceIndex1 = 2;
      var StringSliceIndex2 = 12;

      var firstHalf = (Math.random() + '').slice(StringSliceIndex1, StringSliceIndex2);
      var secondHalf = (Math.random() + '').slice(StringSliceIndex1, StringSliceIndex2);

      return firstHalf.concat(secondHalf);
    },

    /**
     * ajax simple no-jquery post with fixed headers
     *
     * @param postUrl
     * @param postBody
     */
    ajaxPost: function ajaxPost(postUrl, postBody) {
      var xhr;

      // IE8 and IE9 need to use XDomainRequest for CORS requests
      if (utils.useXDomainRequest(postUrl)) {
        xhr = new window.XDomainRequest();
      } else if (window.XMLHttpRequest) {
        // IE7+, Firefox, Chrome, Opera, Safari
        xhr = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        // IE6, IE5
        xhr = new window.ActiveXObject('Microsoft.XMLHTTP');
      } else {
        return;
      }

      xhr.open('POST', postUrl, true);
      if (typeof xhr.setRequestHeader !== 'undefined') {
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Accept', 'application/json, text/javascript, */*;');
        //xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      }
      xhr.send(postBody);
    },

    parseConfig: function parseConfig(options) {
      var queue, gasScheme, gasServer, gasUrl, serverName, productName, subProductName, version, session, sen, sourceIP, atlPath, ajax, max, storageKey, user, publishInterval, saveInterval;

      if (typeof options === 'undefined' || typeof options['queue'] === 'undefined') {
        var AJS = window.AJS = window.AJS || {};
        AJS.EventQueue = AJS.EventQueue || [];
        queue = AJS.EventQueue;
      } else {
        queue = options['queue'];
      }

      if (typeof options === 'undefined' || typeof options['analyticsscheme'] === 'undefined') {
        gasScheme = 'https';
      } else {
        gasScheme = options['analyticsscheme'];
      }

      if (typeof options === 'undefined' || typeof options['analyticsserver'] === 'undefined') {
        gasServer = 'analytics.atlassian.com';
      } else {
        gasServer = options['analyticsserver'];
      }

      if (typeof options === 'undefined' || typeof options['analyticsurl'] === 'undefined') {
        gasUrl = '/analytics/events';
      } else {
        gasUrl = options['analyticsurl'];
      }

      if (typeof options === 'undefined' || typeof options['server'] === 'undefined') {
        serverName = this.getServerName();
      } else {
        serverName = options['server'];
      }

      if (typeof options === 'undefined' || typeof options['product'] === 'undefined') {
        productName = this.getProductNameFromServerName(serverName);
      } else {
        productName = options['product'];
      }

      if (typeof options === 'undefined' || typeof options['subproduct'] === 'undefined') {
        subProductName = this.getSubdomain(serverName);
        if (typeof subProductName === 'undefined') {
          subProductName = '-';
        }
      } else {
        subProductName = options['subproduct'];
      }

      if (typeof options === 'undefined' || typeof options['version'] === 'undefined') {
        version = null;
      } else {
        version = options['version'];
      }

      if (typeof options === 'undefined' || typeof options['session'] === 'undefined') {
        session = null;
      } else {
        session = options['session'];
      }

      if (typeof options === 'undefined' || typeof options['sen'] === 'undefined') {
        sen = null;
      } else {
        sen = options['sen'];
      }

      if (typeof options === 'undefined' || typeof options['sourceip'] === 'undefined') {
        sourceIP = null;
      } else {
        sourceIP = options['sourceip'];
      }

      if (typeof options === 'undefined' || typeof options['atlpath'] === 'undefined') {
        atlPath = this.getAtlPath();
      } else {
        atlPath = options['atlpath'];
      }

      if (typeof options === 'undefined' || typeof options['ajax'] === 'undefined') {
        ajax = this.ajaxPost;
      } else {
        ajax = options['ajax'];
      }

      if (typeof options === 'undefined' || typeof options['maxevents'] === 'undefined') {
        max = this.MAXEVENTS;
      } else {
        max = options['maxevents'];
      }

      if (typeof options === 'undefined' || typeof options['storage_key'] === 'undefined') {
        storageKey = this.STORAGE_KEY_PREAMBLE + this.generateRandomStorageKey() + this.generateRandomStorageKey();
      } else {
        storageKey = options['storage_key'];
      }

      if (typeof options === 'undefined' || typeof options['user'] === 'undefined') {
        user = 'default';
      } else {
        user = options['user'];
      }

      if (typeof options === 'undefined' || typeof options['publish_interval'] === 'undefined') {
        publishInterval = this.PUBLISH_INTERVAL;
      } else {
        publishInterval = options['publish_interval'];
      }

      if (typeof options === 'undefined' || typeof options['save_interval'] === 'undefined') {
        saveInterval = this.SAVE_INTERVAL;
      } else {
        saveInterval = options['save_interval'];
      }

      return {
        queue: queue,
        gasScheme: gasScheme,
        gasServer: gasServer,
        gasUrl: gasUrl,
        serverName: serverName,
        productName: productName,
        subProductName: subProductName,
        version: version,
        session: session,
        sen: sen,
        sourceIP: sourceIP,
        atlPath: atlPath,
        post: ajax,
        maxevents: max,
        storageKey: storageKey,
        user: user,
        publishInterval: publishInterval,
        saveInterval: saveInterval
      };
    },

    /**
     * Does the actual ajax call to the server
     *
     * @param events {object[]}
     * @param [ajaxCall] {function}
     * @returns {*} ajax post result
     */
    pushToServer: function pushToServer(events, ajaxCall) {
      var ajax = typeof ajaxCall !== 'undefined' ? ajaxCall : this.config.post;
      var postTo = this.config.gasScheme + '://' + this.config.gasServer + this.config.gasUrl;
      var postObject = { events: events };
      var postString = JSON.stringify(postObject);

      ajax(postTo, postString);
    },

    /**
     * Supplementary function; Adds all events from a given array, to the destination one.
     * Adds a few common parameters to each of the events
     *
     * @param inputEvents Array to take events from
     * @param resultingArray Array to add events to
     * @param state State object contains serverName, productName, subProductName and user
     */
    addEventsToArray: function addEventsToArray(inputEvents, resultingArray, state) {

      if (typeof state === 'undefined' || typeof state['server'] === 'undefined' || typeof state['product'] === 'undefined' || typeof state['subproduct'] === 'undefined' || typeof state['user'] === 'undefined') {
        return;
      }

      for (var i in inputEvents) {
        if (inputEvents.hasOwnProperty(i)) {
          var e = inputEvents[i];
          if (resultingArray.length >= this.config.maxevents) {
            break;
          }
          if (e.name && e.properties) {
            // check and update event contents
            var event = {
              name: e.name,
              properties: e.properties,
              serverTime: e.time || new Date().getTime(),
              server: state.server,
              user: e.user || state.user,
              product: state.product,
              subproduct: state.subproduct,
              version: state.version,
              session: state.session,
              sen: state.sen,
              sourceIP: state.sourceIP,
              atlPath: state.atlPath
            };
            resultingArray.push(event);
          }
        }
      }
    },

    /**
     * Does trawl through the queue events and if finds any packages them up
     * and calls SenderNS.pushToServer for ajax post
     *
     * @param pushServer
     */
    publishFromQueueAndStorage: function publishFromQueueAndStorage(pushServer) {
      try {
        var pushEvents = typeof pushServer !== 'undefined' ? pushServer : this.pushToServer.bind(this);
        var events = [];
        if (this.config.queue.length < 1 && (typeof this.storage === 'undefined' || this.storage.length < 1)) {
          return;
        }
        var state = {
          server: this.config.serverName,
          user: this.config.user,
          product: this.config.productName,
          subproduct: this.config.subProductName,
          version: this.config.version,
          session: this.config.session,
          sen: this.config.sen,
          sourceIP: this.config.sourceIP,
          atlPath: this.config.atlPath
        };
        this.addEventsToArray(this.config.queue, events, state);
        var storedEvents = this.popEventsFromStorage();
        this.addEventsToArray(storedEvents, events, state);

        this.config.queue.length = 0;

        // POST events to the server
        if (events && events.length) {
          pushEvents(events);
        }
      } catch (e) {
        //intentionally left blank
      }
    },

    /**
     * Serialises events list to a string.
     * @param events Array of event objects
     * @returns {*} JSON string
     */
    serialiseEventsToString: function serialiseEventsToString(events) {
      return JSON.stringify(events);
    },

    /**
     * De-serialises string to a JSON.
     * @param eventsString string containing JSON object
     * @returns {*} events Array of event objects
     */
    deserialiseEvents: function deserialiseEvents(eventsString) {
      return JSON.parse(eventsString);
    },

    /**
     * Stores events from the parameter to the sessionStorage
     * @param events
     */
    storeEvents: function storeEvents(events) {
      if (typeof this.storage === 'undefined') {
        return;
      }
      try {
        if (this.storage[this.config.storageKey]) {
          var olderEvents = this.deserialiseEvents(this.storage[this.config.storageKey]) || [];
          if (olderEvents.length < this.config.maxevents) {
            olderEvents.push.apply(olderEvents, events);
          }
          events = olderEvents;
        }

        this.storage.setItem(this.config.storageKey, this.serialiseEventsToString(events));
      } catch (e) {// swallow; lose events; storage issues
      }
    },

    /**
     * Takes all events from the sessionStorage, removes them from sessionStorage and returns them
     * @returns {*} events Array
     */
    popEventsFromStorage: function popEventsFromStorage() {
      if (typeof this.storage === 'undefined') {
        return [];
      }
      try {
        if (this.storage[this.config.storageKey]) {
          var events = this.deserialiseEvents(this.storage[this.config.storageKey]);
          this.storage[this.config.storageKey] = this.serialiseEventsToString([]);
          return events;
        }
      } catch (e) {// swallow; lose events; storage issues
      }
      return [];
    },

    /**
     * Moves all of the events from the queue to the sessionStorage
     */
    moveQueueToStorage: function moveQueueToStorage() {
      if (this.config.queue.length === 0 || typeof this.storage === 'undefined') {
        return;
      }
      this.storeEvents(this.config.queue);
      this.config.queue.length = 0;
    },

    /**
     * Called when this script is sourced. Creates a timer to call SenderNS.publishFromQueueAndStorage in intervals.
     * Also calls moveQueueToStorage each 1000ms to move any queued events to the storage, so to preserve any
     * events in the queue in case user navigates away
     */
    start: function start() {
      this.is_started = true;
      var arrayPush = Array.prototype.push;
      this.config.queue.push = function (obj) {
        obj.time = new Date().getTime();
        arrayPush.call(this.config.queue, obj);
      }.bind(this);
      // first publish a second later
      this.initialSaveTimeout = setTimeout(this.publishFromQueueAndStorage.bind(this), this.config.saveInterval);

      // Snapshot to storage every 1s and post to server every 5s
      this.publishInterval = setInterval(this.publishFromQueueAndStorage.bind(this), this.config.publishInterval);
      this.saveInterval = setInterval(this.moveQueueToStorage.bind(this), this.config.saveInterval);
    },

    /**
     * Publishes saved events and resets intervals
     */
    stop: function stop() {

      this.is_started = false;
      //publish all saved events and stop intervals/timeouts
      this.publishFromQueueAndStorage();
      clearTimeout(this.initialSaveTimeout);
      clearInterval(this.saveInterval);
      clearInterval(this.publishInterval);
    },

    destroy: function destroy() {
      this.stop();
      window['herment-gas-client'] = init;
    }
  };

  return init;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/*global define:false */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
  var utilities = {};
  var internalStorage = {};

  utilities.getLocalStorage = function () {
    return window.localStorage;
  };

  utilities.getSessionStorage = function () {
    return window.sessionStorage;
  };

  utilities.getInternalStorage = function () {
    internalStorage.getItem = function (key) {
      return internalStorage[key];
    };

    internalStorage.setItem = function (key, value) {
      internalStorage[key] = value;
    };

    internalStorage.clear = function () {
      internalStorage = {};
    };

    return internalStorage;
  };

  utilities.getStorage = function () {
    var windowStorage;
    try {
      var localStorage = utilities.getLocalStorage();
      if (typeof localStorage !== 'undefined') {
        windowStorage = localStorage;
      } else {
        windowStorage = utilities.getSessionStorage();
      }
    } catch (e) {
      // ignored
    }

    if (typeof windowStorage === 'undefined') {
      windowStorage = utilities.getInternalStorage();
    }

    return windowStorage;
  };

  utilities.isCORSRequest = function (url) {
    var parser = document.createElement('a');
    parser.href = url;
    return parser.host !== window.location.host;
  };

  utilities.useXDomainRequest = function (url) {
    return utilities.isCORSRequest(url) && !!window.XDomainRequest && (navigator.appVersion.indexOf('MSIE 8.') !== -1 || navigator.appVersion.indexOf('MSIE 9.') !== -1);
  };

  utilities.getCookieValue = function (name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  };

  return utilities;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ })

},[1246]);


// WEBPACK FOOTER //
// globals-888ef0e3b232c28a3448.js